import { useMemo } from "react";
import stringify from "fast-json-stable-stringify";

import { type DatatableColumn, DatatableRowData } from "../datatable-types";
import { simpleHash } from "../datatable-utils/simple-hash";

import { type DataTableContextProviderProps } from "./datatable-context-props";
import { PrepareInitialContextWithViewProvider } from "./prepare-initial-context-with-view-provider";

function hashRowContent<TData extends DatatableRowData>(row: TData): string {
  return simpleHash(stringify(row));
}

export const DataTableContextProvider = <TData extends DatatableRowData>({
  data,
  columns,
  getRowCacheKey = hashRowContent,
  ...props
}: DataTableContextProviderProps<TData>) => {
  const rowListWithCacheKey = useMemo(() => {
    return data.map((row) => ({ ...row, __cacheKey: getRowCacheKey(row) }));
  }, [data, getRowCacheKey]);

  return (
    <PrepareInitialContextWithViewProvider
      {...props}
      data={rowListWithCacheKey}
      columns={columns as DatatableColumn<TData & { __cacheKey: string }>[]}
    />
  );
};
